import axios from 'axios'
import Swal from 'sweetalert2'

export default {
    state:{
        contactos:[],
    },
    mutations:{
        setContactos(state,data){ state.contactos=data},

        deleteContacto(state,id){
            const indice = state.contactos.findIndex(elemento=>elemento.idcontacto == id);
            state.contactos.splice(indice, 1)
        },
        pushContacto(state,data){
             //Buscamos el indice por su id
             const indice = state.contactos.findIndex(elemento=>elemento.idcontacto == data.idcontacto);
             if (indice > -1){
                //Asignamos la data en el indice encontrado
                Object.assign(state.contactos[indice], data)
             }else{
                 //Sino existe el indice insertamos el item
                 state.contactos.push(data)
             }
             
        }
    },
    actions:{
        async getContactos({commit,getters}){
            try {
                const {data} = await axios.get(`${getters.apiUrl}/contactos/${getters.getIdPersona}`,{headers:{'auth-user': getters.getToken}})
                commit("setContactos",data)
            } catch (error) {
                commit("setContactos",[])
                console.error(error)
            }
        },
        async postContacto({commit,getters},item){
            item.idpersona = getters.getIdPersona;
            try {
                const {data}=await axios.post(`${getters.apiUrl}/contactos`,item)
                commit("pushContacto",data)
                swalOk()
            } catch (error) {
                console.error(error)
                swalError('No pudo crearse el registro')
            }
        }, 
        async putContacto({commit,getters},item){
            try {
              const {data} = await axios.put(`${getters.apiUrl}/contactos/${item.idcontacto}`,item)
              commit("pushContacto",data)
              swalOk()
            } catch (error) {
                console.error(error)
                swalError('No pudo actualizar el registro')
            }
        },
        async deleteContacto({commit,getters},id){
            try {
                await axios.delete(`${getters.apiUrl}/contactos/${id}`)
                commit("deleteContacto",id)
                swalOk()
            } catch (error) {
                console.error(error)
                swalError('No pudo eliminarse el registro')
            }
        }
    },
    getters: {
        getContactos(state){
            return state.contactos;
        },
    }
}

function swalOk(){
    Swal.fire({       
        icon: 'success',
        title: '¡Realizado!',
        showConfirmButton: false,
        timer: 1500
    })
}

function swalError(message){
    Swal.fire({       
        icon: 'error',
        title: 'Error',
        text:message
    })
}